<div class="container gt-auth-block">
  <div class="row">
    <div class="col-xs-12 d-md-none d-sm-block py-4">
      <div class="gt-logo-mobile">
        <img
          ngSrc="../../../assets/images/Guard_Tracker-Stacked-{{
            currentTheme
          }}.avif"
          alt="Guard Tracker"
          width="160"
          height="160"
          priority
          as="image"
        />
      </div>
    </div>
    <div class="col-xs-12 d-none d-md-block py-4">
      <div class="gt-logo-desktop">
        <img
          ngSrc="../../../assets/images/Guard_Tracker-Lateral_Long_{{
            currentTheme
          }}.avif"
          alt="Guard Tracker"
          width="384"
          height="96"
          priority
          as="image"
        />
      </div>
    </div>
  </div>

  @if (displayMessage) {
    <div class="alert alert-primary" role="alert">
      {{ displayMessage }}
    </div>
  }
  @if (!userLinkedSubscribers?.length) {
    <!-- Install App -->
    @if (!isPWAInstalled && deferredPWAInstallPrompt) {
      <div class="text-center d-sm-block d-md-none">
        <button class="btn-sm btn btn-success mb-4" (click)="installPWAApp()">
          Install App
        </button>
      </div>
    }
    <gtapp-user-login
      [loginEmail]="loginEmail"
      (emitData)="emitLoggedInData($event)"
    >
    </gtapp-user-login>

    <div class="mt-5 text-center small">
      {{ currentAppVersion ? "v" + currentAppVersion : "" }}
    </div>
    @if (minSupportVersionDevice?.id) {
      <div class="alert alert-warning text-center mt-5">
        Outdated browser detected, please update your web browser for the best
        experience.
      </div>
    }
  }
  @if (userLinkedSubscribers?.length) {
    <div>
      <div class="fs-5 mb-2 text-center">Select Company</div>
      <div class="d-flex flex-wrap gap-3 justify-content-center">
        @for (account of userLinkedSubscribers; track account) {
          <div
            role="button"
            (click)="selectSubscriber(account)"
            class="hover bg-secondary-subtle px-4 py-2 border-primary text-dark rounded"
          >
            <div class="">{{ account?.email }}</div>
            <div class="">{{ account?.name }}</div>
          </div>
        }
      </div>
    </div>
  }
</div>
